import { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import WrapperVisionMissionValue from "./WrapperVisionMissionValue";

function HomeIntro({ hostpitalAbout }) {
  const [homeIntroData, setHomeIntroData] = useState({});
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/home");
    setHomeIntroData(response?.data);
  };


  return (
    <section id="section-about" className="section-about pt-0 pb-0 mb-0">
      <div className="container">
        <div className="row my-3 align-items-stretch">
          {homeIntroData &&
            (homeIntroData?.video_link || homeIntroData?.short_summary) && (
              <>
                <div className="col-lg-6 col-md-12 col-12 pt-5 classic-who-we-are">
                  <div
                    className="about-vedio-frame w-100"
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.video_link?.replace(
                        /src="([^"]+)"/,
                        (match, p1) => {
                          const newUrl = new URL(p1);
                          newUrl.searchParams.set("autoplay", "1");
                          newUrl.searchParams.set("rel", "0");
                          newUrl.searchParams.set("mute", "1"); // ✅ Mute video
                          return `src="${newUrl.toString()}"`;
                        }
                      ),
                    }}
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-12 pt-5">
                  <div className="title-wrap relative mb-3">
                    <div className="section-title margin-bottom-25 animated fadeInDown visible">
                      <h2 className="section-title mb-0 text-uppercase">
                        {homeIntroData?.main_heading}
                      </h2>
                      <span className="section-border-bottom"></span>
                    </div>
                    <div className="pad-top-15">
                      <p className="mb-0">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: homeIntroData?.short_summary,
                          }}
                        ></span>
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}

          {hostpitalAbout?.about_short_heading && hostpitalAbout?.about_short_description && (
            <div className=" mt-5">
              <div className="title-wrap text-center mb-0">
                <div className="section-title mb-5">
                  <h2 className="title text-uppercase mb-0">
                    {hostpitalAbout.about_short_heading}
                    <span className="theme-color"></span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
                <div className=" mb-0">
                  <p
                    className="mb-0 about-intro-data-descr"
                    dangerouslySetInnerHTML={{
                      __html: hostpitalAbout.about_short_description,
                    }}
                  ></p>
                </div>
              </div>
            </div>
          )}

          {/* {sitedata?.manage_home_page?.vision_mission_values?.Status === 1 &&
            <WrapperVisionMissionValue
              principles={homeIntroData?.principles}
              siteType={sitedata?.site_type}
            />
          } */}

          {/* <VisionMissionValue 
            principles={homeIntroData?.principles} 
            siteType={sitedata?.site_type} 
          /> */}
        </div>
      </div>
    </section>
  );
}

export default HomeIntro;
